import { Component } from 'react';

class BodyTop extends Component {
	componentDidMount() {
		/* Naver Analytics */
		const script = document.createElement('script');
		script.src = '//wcs.naver.net/wcslog.js';
		script.type = 'text/javascript';
		script.async = true;
		document.body.appendChild(script);

		const inlineScript = document.createElement('script');
		inlineScript.type = 'text/javascript';
		inlineScript.innerHTML = `
            if(!wcs_add) var wcs_add = {};
            wcs_add["wa"] = "1c770cc317899f0";
            if(window.wcs) {
                wcs_do();
            }
        `;
		document.body.appendChild(inlineScript);
		/* End Naver Analytics */
	}

	render() {
		return (
			<>
				{/* Google Tag Manager (noscript) */}
				<noscript>
					<iframe
						src="https://www.googletagmanager.com/ns.html?id=GTM-KRTQCGT8"
						height="0"
						width="0"
						style={{ display: 'none', visibility: 'hidden' }}
						title="Google Tag Manager"></iframe>
				</noscript>
				{/* End Google Tag Manager (noscript) */}
			</>
		);
	}
}

export default BodyTop;
